var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g(_vm._b({attrs:{"value":_vm.value_}},'b-form-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }